module.exports = __webpack_public_path__ + "img/service-course.d8ee13b7.png";